var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36ZM25.1379 10L19.3126 16.7714H19.3123L25.6479 25.9918H20.9884L16.722 19.7828L11.3805 25.9918H10L16.1091 18.8909L10 10H14.6595L18.6994 15.8795L23.7575 10H25.1379ZM16.8029 18.0839L17.4219 18.9692V18.9696L21.6378 24.9998H23.7582L18.5918 17.6098L17.9728 16.7245L13.9982 11.0392H11.8779L16.8029 18.0839Z","fill":"white"}));
}

X.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = X;

X.default = X;
